var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { tabClasses } from '@mui/material/Tab';
export var createMuiTabOverrides = function (_a) {
    var _b, _c;
    var tokens = _a.tokens, spacing = _a.spacing, breakpoints = _a.breakpoints, typography = _a.typography, mixins = _a.mixins;
    return {
        variants: [
            {
                props: { fullWidth: true },
                style: {
                    '&:first-child': {
                        marginLeft: spacing(3),
                    },
                },
            },
        ],
        styleOverrides: {
            root: (_b = {
                    paddingLeft: spacing(0.5),
                    paddingRight: spacing(0.5),
                    margin: spacing(0, 1.5),
                    minWidth: 'unset'
                },
                _b[breakpoints.up('sm')] = {
                    minWidth: 'unset',
                },
                _b['&:first-child'] = {
                    marginLeft: 0,
                },
                _b),
            textColorPrimary: (_c = {},
                _c["&.".concat(tabClasses.selected)] = {
                    color: tokens.color_fg_selected,
                },
                _c['&:hover'] = {
                    color: tokens.color_fg_selected,
                },
                _c['&:focus-visible'] = __assign({}, mixins.focusRing({ type: 'inset' })),
                _c.color = tokens.color_fg_link_subtle,
                _c.fontWeight = typography.fontWeightRegular,
                _c),
        },
    };
};
